import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchHolidays(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/holiday/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchHoliday(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/holiday/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addHoliday(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/holiday', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteHoliday(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/holiday', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
    

  },
}
